import { useTheme } from '@/shared/context/ThemeContext';
import { Button } from '@/shared/ui/Button';

const nextTheme = { light: 'dark', dark: 'system', system: 'light' };

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      className="size-10 px-0"
      onClick={() => setTheme(nextTheme[theme])}
      aria-label={`Theme: ${theme}. Switch to ${nextTheme[theme]}.`}
      title={`Theme: ${theme}`}
    >
      <span aria-hidden="true">{theme === 'dark' ? '☾' : theme === 'light' ? '☀' : '◐'}</span>
    </Button>
  );
}
